module.exports = __webpack_public_path__ + "img/php.4a378c13.svg";